import ContactDetailApp from "contact/detail/app";
import ContactListApp from "contact/list/app";
import ContactMergeApp from "contact/merge/app";
import {
  type RouteObject,
} from "react-router";

declare let viewModel: any;

export const contactRoute: RouteObject = {
  path: "contact",
  children: [{
    index: true,
    loader: () => viewModel,
    Component: ContactListApp,
  }, {
    path: ":key",
    loader: () => viewModel,
    Component: ContactDetailApp,
  }, {
    path: ":key/merge/:mergeKey",
    loader: () => viewModel,
    Component: ContactMergeApp,
  }]
};